import { useCallback, useState } from 'react';

export type WorkspaceSortDir = 'asc' | 'desc';

export function useTableSort({
  defaultSortBy,
  defaultSortDir = 'asc',
}: {
  defaultSortBy: string;
  defaultSortDir?: WorkspaceSortDir;
}) {
  const [sortBy, setSortBy] = useState(defaultSortBy);
  const [sortDir, setSortDir] = useState<WorkspaceSortDir>(defaultSortDir);

  const toggleSort = useCallback((key: string, dir?: WorkspaceSortDir) => {
    if (dir) {
      setSortBy(key);
      setSortDir(dir);
      return;
    }
    setSortBy((prevKey) => {
      if (prevKey === key) {
        setSortDir((prevDir) => (prevDir === 'asc' ? 'desc' : 'asc'));
        return prevKey;
      }
      setSortDir('asc');
      return key;
    });
  }, []);

  return { sortBy, sortDir, toggleSort, setSortBy, setSortDir };
}
